import React from "react";
import LandingPageComponent from "./landingPage.component";

const LandingPageContainer = () => {
  return <LandingPageComponent />;
};

export default LandingPageContainer;
